import React, { useEffect, useState } from "react";
import "./PortfolioPerformanceReport.scss";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const PortfolioPerformanceReport = ({startDate, endDate, duration, isCustomFilter}) => {
  const [reportData, setReportData] = useState([]);
  let user = useSelector((state) => state.login);

  useEffect(()=> {
    console.log("PortfolioPerformanceReport===============",user);
    getReportData();
  },[duration, isCustomFilter]);

  const columns = [
    {
      label: 'Loan ID',
      getValue: (row) => row.li?.LoanID ?? ''
    },
    {
      label: 'Borrower Name',
      // getValue: (row) => row.record?.BorrowerName ?? ''
      getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
    },
    {
      label: 'Loan Amount',
      getValue: (row) => row.li?.LoanAmount ?? '',
      align: 'right',
      amount: true
    },
    {
      label: 'Outstanding Balance',
      getValue: (row) => row.record?.OutstandingBalance ?? '',
      align: 'right',
      amount: true
    }
  ];

  const getReportData = async() => {
    try {
      const response = await commonRunQuery(257, `${startDate}/${endDate}`);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
        setReportData(reportsArray);
        console.log("PortfolioPerformanceReport_getReportData==========",reportsArray);
      } else {
        console.log("PortfolioPerformanceReport_else==========");
        setReportData([]);
      }
      console.log("getReportData---------------",response);
    } catch (error) {
      console.log("getReportData_error==========",error);
    }
  }
  
  return (
      <Box>
        <LoanReportsTable 
          data={reportData} 
          columns={columns} 
          title="Portfolio Performance Report" 
          formatRow={(row) => [
            row.li?.LoanID,
            row.record?.BorrowerName,
            row.li?.LoanAmount,
            row.record?.OutstandingBalance,
          ]}
          author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
        />
      </Box>
  )
}

export default PortfolioPerformanceReport;
